import React from 'react';
import { 
  Box, 
  Button, 
  Heading, 
  Text, 
  VStack, 
  Flex, 
  Image,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useColorModeValue
} from '@chakra-ui/react';
import { useWeb3 } from '../lib/Web3Provider';

const ConnectWallet: React.FC = () => {
  const { connect, connecting, error } = useWeb3();
  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Flex 
      w="full" 
      minH="60vh" 
      align="center" 
      justify="center" 
      direction="column"
      p={5}
    >
      <Box 
        p={8} 
        maxW="lg"
        bg={bgColor}
        borderWidth="1px"
        borderColor={borderColor}
        boxShadow="lg"
        borderRadius="lg"
        textAlign="center"
      >
        <VStack spacing={6}>
          <Image 
            alt="Metamask Logo" 
            src="/metamask-fox.svg" 
            boxSize="100px"
            fallbackSrc="https://metamask.io/images/metamask-fox.svg"
          />

          <Heading as="h2" size="xl">
            Connect Your Wallet
          </Heading>

          <Text fontSize="lg">
            Please connect your Ethereum wallet to interact with SmartLaw tokens on Polygon.
          </Text>

          <Text color="gray.500">
            You'll need:
          </Text>

          <VStack align="start" spacing={2} mt={2}>
            <Flex align="center">
              <Box w={2} h={2} borderRadius="full" bg="green.500" mr={2} />
              <Text>MetaMask or other Web3 wallet</Text>
            </Flex>
            <Flex align="center">
              <Box w={2} h={2} borderRadius="full" bg="green.500" mr={2} />
              <Text>Polygon network configured in your wallet</Text>
            </Flex>
            <Flex align="center">
              <Box w={2} h={2} borderRadius="full" bg="green.500" mr={2} />
              <Text>MATIC tokens for gas fees</Text>
            </Flex>
          </VStack>

          {error && (
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              <AlertTitle mr={2}>Connection Error</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <Button 
            colorScheme="blue" 
            size="lg" 
            isLoading={connecting}
            loadingText="Connecting..."
            onClick={connect}
            w="full"
            mt={4}
          >
            Connect Wallet
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default ConnectWallet;